import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LocalService {
    private local = './assets/data/';
    private currency = 'currency.json';
    constructor(private http: HttpClient) {}

    public getCurrency = (): Observable<any> => {
        return this.http.get(`${this.local}${this.currency}`);
    }

    get supportedLanguages(): Array<string> {
        return ['en'];
    }

    public isSupportedLanguage(lang): boolean {
        return this.supportedLanguages.includes(lang);
    }

    get currentLang(): string {
        return localStorage.getItem('lang');
    }

    get defaultLanguage(): string {
        if (this.isSupportedLanguage(this.browserLanguage)) {
            return this.browserLanguage;
        }
        return 'en';
    }

    set currentLang(lang) {
        if (!this.isSupportedLanguage(lang)) {
            return;
        }
        localStorage.setItem('lang', lang);
    }

    get browserLanguage(): string {
        const lang = navigator.language;
        // don't then part after the dash, en-us, es-334
        return lang.split('-')[0];
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/local.service.ts